<template>
  <ul class="form-item-list">
    <li><h3><b>[여성의 경우]</b> 현재 임신 중이십니까?</h3></li>
    <li class="text-center">
      <el-checkbox
        class="round"
        label="예"
        border
        v-model="yes"
        :error="formData.answer.error"
        @change="event => updateChecked(event, 'yes')"
      />
      <el-checkbox
        class="round"
        label="아니오"
        border
        v-model="no"
        :error="formData.answer.error"
        @change="event => updateChecked(event, 'no')"
      />
    </li>
    <li v-if="yes">
      <div class="detail-form">
        <el-row :gutter="20" class="my-1">
          <div class="label mx-0">임신기간</div>
          <el-col :span="12">
            <el-input
              type="text"
              v-model="detail['임신기간'].value[0].value"
              :placeholder="detail['임신기간'].value[0].placeholder"
              @input="changeDetail('임신기간', 0)"
            >
              <span slot="suffix">개월</span>
            </el-input>
          </el-col>
          <el-col :span="12">          
            <el-input
              type="text"
              v-model="detail['임신기간'].value[1].value"
              :placeholder="detail['임신기간'].value[1].placeholder"
              @input="changeDetail('임신기간', 1)"
            >
              <span slot="suffix">주</span>
            </el-input>
          </el-col>
        </el-row>

        <el-row>
          <element-radio
            v-model="detail['태아상태'].value"
            :error="detail['태아상태'].error"
            :label="detail['태아상태'].label"
            :items="detail['태아상태'].items"
            @input="changeDetail('태아상태')"
          />
        </el-row>
      </div>
    </li>
  </ul>
</template>

<script>
import { Checkbox, Row, Col, Input } from 'element-ui';

export default {
  name: 'Pregnant',
  props: ['formData'],
  components: {
    [Checkbox.name]: Checkbox,
    [Row.name]: Row,
    [Col.name]: Col,
    [Input.name]: Input,
  },
  data() {
    return {
      yes: this.formData.answer.value === '예',
      no: this.formData.answer.value === '아니오',
      detail: {
        '임신기간': {
          label: "임신기간",
          value: [
            { placeholder: '예:5', value: '' },
            { placeholder: '예:2', value: '' },
          ],
          error: "",
          placeholder: "임신기간",
          validations: [
            { type: "required", message: "필수항목입니다" }
          ]
        },
        '태아상태': {
          label: "태아상태",
          value: "",
          error: "",
          validations: [
            { type: "required", message: "필수항목입니다" }
          ],
          items: [
            { label: '단태아', value: '단태아' },
            { label: '쌍태아', value: '쌍태아' },
          ]
        },
      }
    }
  },
  mounted() {
    this.$emit('update', {
      type: '임신',
      value: {
        '개월': '',
        '주': '',
        '태아': ''
      }
    });
  },
  methods: {
    changeDetail() {
      let updateData = {
        type: '임신',
        value: {
          '개월': '',
          '주': '',
          '태아': ''
        }
      };

      Object
        .keys(this.detail)
        .map(key => {
          if (key === '임신기간') {
            updateData.value = {
              ...updateData.value,
              개월: this.detail[key].value[0].value,
              주: this.detail[key].value[1].value
            };

            return;
          }

          updateData.value.태아 = this.detail[key].value;
        });

      this.$emit('update', updateData);
    },
    isEmptyDetailData() {
      return Object.keys(this.detail).every(key => {
        const { value } = this.detail[key];
        const isArrayData = Array.isArray(value) ? value : [value];

        return isArrayData.every(v => v !== '');
      });
    },
    updateChecked(event, type) {
      const reverse = type === 'yes' ? 'no' : 'yes';
      this.$data[reverse] = !event;

      if (type === 'yes') {
        console.log(this.isEmptyDetailData())
      }

      this.$emit('update', { type: 'answer', value: type });
    },
  }
}
</script>

<style lang="scss" scoped>
  .form-item-list {
    li {
      &.text-center {
        text-align: center;
      }
      h3 {
        font-size: 18px !important;
      }
      p {
        span.blue {
          color: #174BE6;
        }
      }
      .el-checkbox {
        &.round {
          width: 40%;
          text-align: left;

          .el-checkbox__inner {
            border-radius: 50% !important;
          }
        }
      }
    }
    .detail-form {
      h3 {
        margin-bottom: 2*$unit;
      }
      .el-row {
        margin-bottom: 2*$unit;

        &.my-1 {
          margin-bottom: $unit;
        }
        .mx-0 {
          margin-left: 10px;
          margin-right: 10px;
          margin-bottom: $unit;
        }
        .el-input {
          height: 54px;
    
          .el-input__inner {
            height: 54px;
            border-radius: 0;
          }
    
          .el-input__suffix-inner {
            line-height: 54px;
            color: #000;
          }
        }

        .element-select {
          .label {
            display: none;
          }
          .body {
            margin-top: 0;
          }
        }

        .element-radio {
          display: flex;
          justify-content: space-between;

          ul {
            li {
              margin-top: 0 !important;
              padding-right: 2*$unit;

              &::before {
                width: 1.5*$unit;
                height: 1.5*$unit;
              }
              &::after {
                width: 0.8*$unit;
                transform: rotate(-45deg) translateX(0.4rem) translateY(0.2rem);
              }
            }
          }
        }
      }
    }
  }
</style>